import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import IncentivePrograms from './pages/IncentivePrograms';
import ProgramForm from './pages/ProgramForm';
import ProgramDetails from './pages/ProgramDetails';
import EventsPage from './pages/EventsPage';
import Header from './components/Header';
import {ProtectedApp, SavingsAuthProvider} from "savings-js";

// Layout component that includes the header
const AuthenticatedLayout = () => {
  return (
    <>
      <Header />
      <div className="app-content">
        <Outlet />
      </div>
    </>
  );
};

function App() {

  return (
      <SavingsAuthProvider
          hubUrl={"http://localhost:5000"}
          keycloakUrl={process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.savingscollaborative.org'}
          realm={process.env.REACT_APP_KEYCLOAK_REALM || "savings"}
          clientId={process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'incentives'}
      >
          <>
              <ProtectedApp>
                  <Router>
                      <Routes>

                          {/* Authenticated routes with header */}
                          <Route element={<AuthenticatedLayout />}>
                              <Route path="/home" element={<Home />} />
                              <Route path="/programs" element={<IncentivePrograms />} />
                              <Route path="/programs/create" element={<ProgramForm />} />
                              <Route path="/programs/edit/:id" element={<ProgramForm />} />
                              <Route path="/programs/details/:id" element={<ProgramDetails />} />
                              <Route path="/events" element={<EventsPage />} />
                          </Route>

                          <Route path="/" element={<Navigate to="/home" />} />
                          <Route path="*" element={<Navigate to="/home" />} />
                      </Routes>
                  </Router>
              </ProtectedApp>
          </>

      </SavingsAuthProvider>

  );
}

export default App;
